export const webConfig = {
    webPortalName : "Art Bharat CMS Portal",
}